import config from "../config";

function url(append = "") {
  if (append[0] !== "/") {
    append = "/" + append;
  }
  return config.api + append;
}

export default url;
